import { ReactElement, ReactNode, useMemo, useState } from 'react';

import IsPlanWorkflowModalOpenContext from './context';
import { ContextValue } from './types';

type Props = {
  children: ReactNode;
};

const IsPlanWorkflowModalOpenContextProvider = ({
  children,
}: Props): ReactElement => {
  const [isPlanWorkflowModalOpen, setIsPlanWorkflowModalOpen] = useState(false);

  const value: ContextValue = useMemo(
    () => [isPlanWorkflowModalOpen, setIsPlanWorkflowModalOpen],
    [isPlanWorkflowModalOpen]
  );

  return (
    <IsPlanWorkflowModalOpenContext.Provider value={value}>
      {children}
    </IsPlanWorkflowModalOpenContext.Provider>
  );
};

export default IsPlanWorkflowModalOpenContextProvider;
